import * as React from "react";
import PoiItem from "./poiitem";
import { PoiSearch } from "../api/poisearch";

interface IPoiListResultsProps {
    poiList: Array<PoiSearch>;
}

const PoiListResults = ({ poiList }: IPoiListResultsProps) => {
    const pois = poiList.map(function (poi) {
        return (<PoiItem poi={poi} key={poi.poiindex} />);
    });

    return (
        <div className="pois-container results-container">
            {pois}
        </div>
    );
}

export default PoiListResults;

